// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ki+rd","photoItem":"styles_photoItem__OnbPY","empty":"styles_empty__-utzf","loader":"styles_loader__lElvq","spin":"styles_spin__JwA0g"};